import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { AUTO_POPULATE_DEFAULT_EMAIL_ADDRESS } from 'constants/featureToggleNames';
import styles from './DetailedChip.styles';
import DetailedChip from './DetailedChip';

export default compose(
  withStyles(styles),
  withFeatureToggles({
    isAutoPopulateDefaultEmailEnabled: AUTO_POPULATE_DEFAULT_EMAIL_ADDRESS,
  }),
)(DetailedChip);
